import { useEffect, useRef } from "react";
import "./CampusBackground.css";

export default function CampusBackground({ contentRef }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    let disposed = false;
    let disposeScene;
    let idleHandle;
    let timeoutHandle;

    const start = async () => {
      const { createCampusScene } = await import("./campusScene");
      if (!disposed && canvasRef.current) {
        disposeScene = createCampusScene(canvasRef.current, contentRef.current);
      }
    };

    // Let the existing headline and controls paint before loading the scenery.
    if ("requestIdleCallback" in window) {
      idleHandle = window.requestIdleCallback(start, { timeout: 1200 });
    } else {
      timeoutHandle = window.setTimeout(start, 100);
    }

    return () => {
      disposed = true;
      if (idleHandle !== undefined) window.cancelIdleCallback(idleHandle);
      if (timeoutHandle !== undefined) window.clearTimeout(timeoutHandle);
      disposeScene?.();
    };
  }, [contentRef]);

  return (
    <div className="campus-background" aria-hidden="true">
      <canvas ref={canvasRef} />
    </div>
  );
}
